import { render, staticRenderFns } from "./ClientAndDepartmentSection.vue?vue&type=template&id=1a3452ea&"
import script from "./ClientAndDepartmentSection.vue?vue&type=script&lang=js&"
export * from "./ClientAndDepartmentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports